"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.catalogsColumns = void 0;
function catalogsColumns(catalogColumnKey, catalogColumnName) {
    return [
        {
            field: 'botanisch',
            headerName: 'Botanisch',
            editable: false,
            type: 'derivedColumn',
        },
        {
            field: 'tb',
            editable: false,
            headerName: 'Tb',
            type: 'derivedColumn',
        },
        {
            field: 'pg',
            editable: false,
            headerName: 'PG',
            type: 'derivedColumn',
        },
        {
            field: 'warengruppe',
            headerName: 'Warengruppe',
            editable: false,
            type: 'derivedColumn',
        },
        {
            field: catalogColumnKey,
            headerName: catalogColumnName,
            editable: true,
            type: 'booleanColumn',
        },
    ];
}
exports.catalogsColumns = catalogsColumns;
